import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Role as AdminRole } from '../../types/Role'

export enum UserType {
  PRESCRIBER = 'prescriber',
  ADMIN = 'admin',
}

type AllRoles = UserType | AdminRole

interface SelectRolesState {
  selectedRole: AllRoles | null
  clinicId?: string | null
  organizationId?: string | null
}

const initialState: SelectRolesState = {
  selectedRole: null,
  clinicId: null,
  organizationId: null,
}

export const OnboardingContextSlice = createSlice({
  name: 'onboardingContext',
  initialState,
  reducers: {
    selectRole: (state, { payload: role }: PayloadAction<AllRoles | null>) => {
      state.selectedRole = role ?? null
    },
    setClinicId: (state, { payload: clinicId = null }: PayloadAction<string | null>) => {
      state.clinicId = clinicId
    },
    setOrganizationId: (
      state,
      { payload: organizationId = null }: PayloadAction<string | null>
    ) => {
      state.organizationId = organizationId ?? null
    },
  },
})

export const { selectRole, setClinicId, setOrganizationId } = OnboardingContextSlice.actions

export default OnboardingContextSlice.reducer
